<template>
  <section class="max-w-6xl mx-auto p-8">
    <header class="mb-8">
      <p class="text-sm text-gray-500">Where are you traveling to?</p>
      <h2 class="text-3xl font-bold">Choose your travel destination</h2>
      <p class="text-gray-500">Pick a mobile data plan for your trip.</p>
    </header>

    <div
      class="mb-8 inline-flex bg-background border border-border rounded-full gap-2 relative before:absolute before:inset-0 before:bg-[repeating-linear-gradient(-45deg,var(--color-border),var(--color-border)_1px,transparent_1px,transparent_6px)] before:opacity-50 before:rounded-full"
    >
      <Motion
        :initial="false"
        :animate="{
          x: activeTab === 'country' ? 0 : '100%',
          width: '50%',
        }"
        :transition="{
          type: 'spring',
          stiffness: 300,
          damping: 30,
        }"
        class="absolute inset-y-0 bg-white shadow rounded-full"
        style="left: 0"
      />

      <button
        v-for="tab in (['country', 'region'] as const)"
        :key="tab"
        @click="activeTab = tab"
        :class="[
          'px-6 py-2 rounded-full transition-colors duration-200 capitalize relative z-10 ',
          activeTab === tab ? 'text-black' : 'text-white',
        ]"
      >
        {{ tab }}
      </button>
    </div>

    <Motion
      :key="activeTab"
      :initial="{ opacity: 0, y: 20 }"
      :animate="{ opacity: 1, y: 0 }"
      :transition="{
        type: 'spring',
        stiffness: 300,
        damping: 30,
      }"
      class="grid grid-cols-1 md:grid-cols-3 gap-2"
    >
      <RegionCard v-for="item in items" :key="item.code" :item="item" />
    </Motion>
  </section>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { Motion } from "motion-v";

import popularRegions from "@/data/popularRegions.json";
import RegionCard from "@/components/landing/region-card.vue";
import type { PopularCountry, PopularRegionGroup } from "@/lib/types";

const activeTab = ref<"country" | "region">("country");
const { countries, regions } = popularRegions;

const items = computed((): PopularCountry[] | PopularRegionGroup[] =>
  activeTab.value === "country" ? countries : regions
);
</script>
